module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"shared":{"users":{"edit":{"privacy_hint_html":"This section will only be visible publicly on your profile if your <a href=\\"%{link}\\" nofollow target=\\"_blank\\">privacy settings</a> allows it to be seen by <strong>all</strong> users."}}}}}}')
  delete Component.options._Ctor
}
